import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth/authSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Re-export commonly used types and actions
export * from './slices/auth/types';
export { loginSuccess, logoutSuccess, updateAuth, setLoading } from './slices/auth/authSlice';